import { PropsWithChildren, createContext, useContext } from 'react';

export type ThemeVariant = 'light' | 'dark';

const ThemeVariantContext = createContext<ThemeVariant>('light');

export const ThemeVariantProvider = ({
  children,
  variant,
}: PropsWithChildren<{ variant: ThemeVariant }>) => (
  <ThemeVariantContext.Provider value={variant}>
    {children}
  </ThemeVariantContext.Provider>
);

export const useThemeVariant = (): ThemeVariant =>
  useContext(ThemeVariantContext);
